import { Button, Menu } from "antd";
import useAuth from "hooks/useAuth";

const AuthButton = ({ auth, mode = 'button', noAdmin = false, children, ...props }) => {
    const { isAuth, adminstration } = useAuth([auth]);

    if (!isAuth) {
        return null;
    }

    if (noAdmin && adminstration) {
        return null
    }

    if (mode === 'button') return <Button {...props}>{children}</Button>
    if (mode === 'menu') return <Menu.Item {...props}>{children}</Menu.Item>
};

export default AuthButton;
